<script lang="ts">
	import type { User } from 'firebase/auth';
	import { analytics } from '$lib/analytics';
	import LoginOrSignUpModal from './LoginOrSignUpModal.svelte';

	export let user: User | null | undefined;
	export let href: string;
	export let eventText: string;
	export let loginOrSignUpModal: LoginOrSignUpModal;
	export let loginOrSignupWhichModal: 'login' | 'sign-up' = 'sign-up';
	export let redirectAfterLogin: string | undefined = undefined;
	export let allowAnonymous: boolean = false;

	function handleClick() {
		if (user === undefined) return;
		analytics.capture('cta_clicked', { text: eventText });
		redirectAfterLogin = href;
		loginOrSignupWhichModal = 'sign-up';
		loginOrSignUpModal.openDialog();
	}
</script>

{#if user || allowAnonymous}
	<a
		class="block w-fit"
		{href}
		on:click={() => analytics.capture('cta_clicked', { text: eventText })}
	>
		<slot />
	</a>
{:else}
	<button class="block w-fit" on:click={handleClick}>
		<slot />
	</button>
{/if}
